import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './constants';
function rootNavComponentDimension(currentState, action) {
  const {
    compName,
    dimensions
  } = action.payload;
  const currDimensions = currentState.rootNav[compName];
  const updatedDimensions = Object.keys(dimensions).reduce((accumulator, dimensionKey) => {
    if (compName === 'VerticalNav' && dimensionKey === 'width') {
      accumulator[dimensionKey] = dimensions[dimensionKey];
    } else if (compName === 'GlobalToolbar' && dimensionKey === 'height') {
      accumulator[dimensionKey] = dimensions[dimensionKey];
    } else if (compName === 'SandboxBanner' && dimensionKey === 'height') {
      accumulator[dimensionKey] = dimensions[dimensionKey];
    } else {
      const currDimensionVal = currDimensions[dimensionKey];
      const dimensionPayload = dimensions[dimensionKey];
      accumulator[dimensionKey] = currDimensionVal + dimensionPayload;
    }
    return accumulator;
  }, Object.assign({}, currDimensions));
  currentState.rootNav[compName] = updatedDimensions;
}
function externalNavComponentDimension(currentState, action) {
  const {
    compName,
    dimensions
  } = action.payload;
  const currDimensions = currentState.rootNav[compName];
  const updatedDimensions = Object.keys(dimensions).reduce((accumulator, dimensionKey) => {
    if (compName === 'Banners' && dimensionKey === 'height') {
      accumulator[dimensionKey] = dimensions[dimensionKey];
    }
    return accumulator;
  }, Object.assign({}, currDimensions));
  currentState.externalNav[compName] = updatedDimensions;
}
const reducers = {
  rootNavComponentDimension,
  externalNavComponentDimension
};
export const navLayoutDimensionsSlice = createSlice({
  name: 'navLayoutDimensions',
  initialState,
  reducers
});
export default navLayoutDimensionsSlice.reducer;